<section>
	<div class="top-bar">
		<div class="header">
			<h2>Aanwezigheid configuratie</h2>
			<div class="subtitle">
				Stel in hoe afwezigheidsredenen meetellen in CumLaude. Wijzigingen worden ’s nachts verwerkt en zijn de volgende dag zichtbaar.
			</div>
		</div>
		<div class="buttons">
			<app-button buttonType="secondary" [enabled]="dirty()" (clickit)="revert()">Annuleren</app-button>
			<app-button [enabled]="dirty()" (clickit)="trySave()">Opslaan</app-button>
		</div>
	</div>
	<div class="tabel">
		<div class="header">
			<div class="reden">Afwezigheidsreden</div>
			<div class="type">Telt mee als</div>
		</div>
		<div class="rows">
			@for (afwezigheidsreden of afwezigheidsredenen(); track afwezigheidsreden.reden; let odd = $odd; let even = $even; let last = $last) {
				<div class="row" [class.odd]="odd" [class.even]="even" [class.last]="last">
					<div class="reden">
						{{ afwezigheidsreden.reden }}
					</div>
					<div class="type">
						<app-toggle-buttons
							[options]="options()"
							[value]="afwezigheidsreden.aanwezig"
							[labelFunction]="getLabel"
							(valueChange)="update(afwezigheidsreden, $event)"
							[small]="true"
						>
						</app-toggle-buttons>
					</div>
				</div>
			}
		</div>
	</div>
</section>
